import { v4 as uuidv4 } from 'uuid';

export function ProductRatingInline() {
	return {
		componentName: 'ProductRatingInline',
		componentId: uuidv4(),
		props: {},
		childrenComponents: [],
	};
}
